module.exports = __webpack_public_path__ + "static/img/title-banner1-type3.b258854.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/6/title-banner1-type3.png
// module id = sDo7
// module chunks = 1